export interface Pain {
  title: string
  lead: string
  items: string[]
  close: string
}

export const pains: Pain[] = [
  {
    title: '😰 Endless Therapy Planning',
    lead: 'Every week you spend hours...',
    items: [
      'Creating new therapy activities...',
      'Preparing worksheets...',
      'Writing treatment goals...',
      'Planning sessions...',
      'Organizing patient materials...',
      'Trying not to repeat the same resources.',
    ],
    close: 'The planning never ends.',
  },
  {
    title: '⚠️ Never Knowing What To Do Next',
    lead: 'You constantly ask yourself...',
    items: [
      'What activity should I use today?',
      'How can I target this communication goal?',
      'Which materials fit this patient best?',
      "How should I structure today's therapy session?",
    ],
    close: 'Soon every appointment feels like starting from zero.',
  },
  {
    title: '📚 Therapy Resources Everywhere',
    lead: 'Everything exists...',
    items: [
      'Worksheets.',
      'Flashcards.',
      'Visual supports.',
      'Goal templates.',
      'Progress notes.',
      'Therapy ideas.',
    ],
    close:
      "But it's scattered across folders, PDFs, notebooks, websites, and years of clinical experience. Nothing is organized into one complete therapy system.",
  },
  {
    title: '😩 Professional Burnout',
    lead: 'Repeating the same process every week.',
    items: [
      'Planning.',
      'Preparing.',
      'Printing.',
      'Documenting.',
      'Searching for new ideas.',
      'Creating resources.',
    ],
    close:
      'Instead of doing what you enjoy most... Helping your patients communicate with confidence.',
  },
]
